module.exports = __webpack_public_path__ + "img/quit-quiz.7c47ee5f.svg";